module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "body"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loginloading),
      expression: "loginloading"
    }],
    staticClass: "login-origion",
    attrs: {
      "element-loading-text": "正在登录中"
    }
  }, [_c('div', {
    staticClass: "logBox"
  }, [_c('form', {
    attrs: {
      "id": "loginForm",
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "platformBox"
  }, [_vm._v("第三方API接口管理平台")]), _vm._v(" "), _c('div', {
    staticClass: "username-line"
  }, [_c('span'), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名",
      "name": "userID",
      "id": "userID",
      "autofocus": ""
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.NextInput('userID')
      }
    },
    model: {
      value: (_vm.user.userID),
      callback: function($$v) {
        _vm.$set(_vm.user, "userID", $$v)
      },
      expression: "user.userID"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i')])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "password-line"
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "name": "password",
      "id": "password"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.NextInput('password')
      }
    },
    model: {
      value: (_vm.user.passWord),
      callback: function($$v) {
        _vm.$set(_vm.user, "passWord", $$v)
      },
      expression: "user.passWord"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i')])], 2)], 1), _vm._v(" "), _c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError),
      expression: "isError"
    }],
    attrs: {
      "title": _vm.errrorMsg,
      "type": "error",
      "closable": false,
      "show-icon": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "verification-line"
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInputVerifyCode()),
      expression: "isInputVerifyCode()"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码",
      "name": "verificationcode",
      "id": "verificationcode"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.NextInput('verificationcode')
      }
    },
    model: {
      value: (_vm.user.verifyCode),
      callback: function($$v) {
        _vm.$set(_vm.user, "verifyCode", $$v)
      },
      expression: "user.verifyCode"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "30px"
    },
    attrs: {
      "id": "v_container"
    }
  })])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "remenber-line",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remenberPassword),
      expression: "remenberPassword"
    }],
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "type": "checkbox",
      "id": "remenber-checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.remenberPassword) ? _vm._i(_vm.remenberPassword, null) > -1 : (_vm.remenberPassword)
    },
    on: {
      "click": function($event) {
        _vm.doRemenberPassword($event)
      },
      "change": function($event) {
        var $$a = _vm.remenberPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.remenberPassword = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.remenberPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remenberPassword = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px",
      "vertical-align": "middle"
    },
    attrs: {
      "for": "remenber-checkbox"
    }
  }, [_vm._v("记住帐号")])]), _vm._v(" "), _c('button', {
    staticClass: "login-btn",
    attrs: {
      "type": "button",
      "id": "login-btn"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("登 录")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-74e007a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/Login.vue
// module id = IaMt
// module chunks = 1